
import { NgModule } from '@angular/core';

import { CidEditProvider } from './cid-edit.provider';
import { CidListProvider } from './cid-list.provider';

export * from './cid-edit.provider';
export * from './cid-list.provider';

export {
  CidListProvider,
  CidEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    CidEditProvider,
    CidListProvider
  ]
})
export class CidBackendModule { }
